var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 23,
    viewBox: "0 0 90 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04749 22.2283L62.0729 22.1333L62.2628 18.9514L64.6373 18.3815L65.4447 16.2919L68.2941 14.6773L70.8111 14.9622L74.2779 12.1128L75.7501 12.2078L76.4625 10.3081L79.1695 8.59847L80.0243 9.73824L83.7285 7.31622L85.0583 8.17105L87.5278 4.8942L88.6201 5.13166L89 1.9023L51.8624 1.61736L26.36 1.42739L25.8851 1.04747L23.7005 1L23.843 3.23201L9.78576 3.27955L8.64598 3.422L8.45602 5.89153L7.0313 6.17648L8.0286 7.64865L7.22126 8.55095L6.50891 11.4004L4.27685 13.585L4.79925 14.9147L2.28225 17.6216L3.08959 20.6136L1 21.7058L1.04749 22.2283Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/TN.78a8333ceeb41c497319baa13234657e.svg";
export { ForwardRef as ReactComponent };